export enum DocTypes {
  /**
   * Bill of Landing.
   * Category: Document.
   */
  BILL_OF_LANDING = 'BL',
  /**
   * Bill of Landing Attachment.
   * Category: Document.
   */
  BILL_OF_LANDING_ATTACHMENT = 'BLAT',
  /**
   * Customs.
   * Category: Document.
   */
  CUSTOMS = 'CUST',
  /**
   * Inspection Certificate.
   * Category: Document.
   */
  INSPECTION_CERTIFICATE = 'NCIC',
  /**
   * Reweigh Certificate.
   * Category: Document.
   */
  REWEIGH_CERTIFICATE = 'WI',
  /**
   * Dimensioner Photo.
   * Category: Inspection Photos.
   */
  DIMENSION_PHOTO = 'DMNR',
  /**
   * Inspection Photo.
   * Category: Operations Photos.
   */
  INSPECTION_PHOTO = 'WRFO',
  /**
   * Trailer Photo.
   * Category: Operations Photos.
   */
  TRAILER_PHOTO = 'TRFO',
  /**
   * Other Photo/Document.
   */
  PICKUP_DIMENSIONER_PHOTO = 'PDFO',
  /**
   * Other Photo/Document.
   */
  OTHER = 'OTHER'
}
